// ISSUE INVOICE LIST
export const ISSUE_INVOICE_LIST = "ISSUE_INVOICE_LIST";
export const ISSUE_INVOICE_LIST_SUCCESS = "ISSUE_INVOICE_LIST_SUCCESS";
export const ISSUE_INVOICE_LIST_FAIL = "ISSUE_INVOICE_LIST_FAIL";
export const ISSUE_INVOICE_LIST_RESET = "ISSUE_INVOICE_LIST_RESET";
export const ISSUE_INVOICE_LIST_COLUMN = "ISSUE_INVOICE_LIST_COLUMN";
export const ISSUE_INVOICE_LIST_VAT_NONE_CODE_COLUMN =
  "ISSUE_INVOICE_LIST_VAT_NONE_CODE_COLUMN";
export const ISSUE_INVOICE_LIST_SALE_HAVE_CODE_COLUMN =
  "ISSUE_INVOICE_LIST_SALE_HAVE_CODE_COLUMN";
export const ISSUE_INVOICE_LIST_SALE_NONE_CODE_COLUMN =
  "ISSUE_INVOICE_LIST_SALE_NONE_CODE_COLUMN";

// INVOICE LIST CREATE
export const ISSUE_INVOICE_CREATE = "ISSUE_INVOICE_CREATE";
export const ISSUE_INVOICE_CREATE_SUCCESS = "ISSUE_INVOICE_CREATE_SUCCESS";
export const ISSUE_INVOICE_CREATE_FAIL = "ISSUE_INVOICE_CREATE_FAIL";
export const ISSUE_INVOICE_CREATE_RESET = "ISSUE_INVOICE_CREATE_RESET";

// INVOICE LIST EDIT
export const ISSUE_INVOICE_EDIT = "ISSUE_INVOICE_EDIT";
export const ISSUE_INVOICE_EDIT_SUCCESS = "ISSUE_INVOICE_EDIT_SUCCESS";
export const ISSUE_INVOICE_EDIT_FAIL = "ISSUE_INVOICE_EDIT_FAIL";
export const ISSUE_INVOICE_EDIT_RESET = "ISSUE_INVOICE_EDIT_RESET";

// INVOICE LIST DETAIL
export const ISSUE_INVOICE_DETAIL = "ISSUE_INVOICE_DETAIL";
export const ISSUE_INVOICE_DETAIL_SUCCESS = "ISSUE_INVOICE_DETAIL_SUCCESS";
export const ISSUE_INVOICE_DETAIL_FAIL = "ISSUE_INVOICE_DETAIL_FAIL";
export const ISSUE_INVOICE_DETAIL_RESET = "ISSUE_INVOICE_DETAIL_RESET";

// LOAD_CONFIG_INVOICE_FIELD
export const LOAD_CONFIG_INVOICE_FIELD = "LOAD_CONFIG_INVOICE_FIELD";
export const LOAD_CONFIG_INVOICE_FIELD_SUCCESS =
  "LOAD_CONFIG_INVOICE_FIELD_SUCCESS";
export const LOAD_CONFIG_INVOICE_FIELD_FAIL = "LOAD_CONFIG_INVOICE_FIELD_FAIL";
export const LOAD_CONFIG_INVOICE_FIELD_RESET =
  "LOAD_CONFIG_INVOICE_FIELD_RESET";

// GET_ENTERPRISE_BY_TAX_CODE
export const GET_ENTERPRISE_BY_TAX_CODE = "GET_ENTERPRISE_BY_TAX_CODE";
export const GET_ENTERPRISE_BY_TAX_CODE_SUCCESS =
  "GET_ENTERPRISE_BY_TAX_CODE_SUCCESS";
export const GET_ENTERPRISE_BY_TAX_CODE_FAIL =
  "GET_ENTERPRISE_BY_TAX_CODE_FAIL";
export const GET_ENTERPRISE_BY_TAX_CODE_RESET =
  "GET_ENTERPRISE_BY_TAX_CODE_RESET";

// RELEASE_ISSUE_INVOICE
export const RELEASE_ISSUE_INVOICE = "RELEASE_ISSUE_INVOICE";
export const RELEASE_ISSUE_INVOICE_SUCCESS = "RELEASE_ISSUE_INVOICE_SUCCESS";
export const RELEASE_ISSUE_INVOICE_FAIL = "RELEASE_ISSUE_INVOICE_FAIL";
export const RESET_RELEASE_ISSUE_INVOICE = "RESET_RELEASE_ISSUE_INVOICE";

// REPLACE_ISSUE_INVOICE
export const REPLACE_ISSUE_INVOICE = "REPLACE_ISSUE_INVOICE";
export const REPLACE_ISSUE_INVOICE_SUCCESS = "REPLACE_ISSUE_INVOICE_SUCCESS";
export const REPLACE_ISSUE_INVOICE_FAIL = "REPLACE_ISSUE_INVOICE_FAIL";
export const RESET_REPLACE_ISSUE_INVOICE = "RESET_REPLACE_ISSUE_INVOICE";

// ADJUST_ISSUE_INVOICE
export const ADJUST_ISSUE_INVOICE = "ADJUST_ISSUE_INVOICE";
export const ADJUST_ISSUE_INVOICE_SUCCESS = "ADJUST_ISSUE_INVOICE_SUCCESS";
export const ADJUST_ISSUE_INVOICE_FAIL = "ADJUST_ISSUE_INVOICE_FAIL";
export const RESET_ADJUST_ISSUE_INVOICE = "RESET_ADJUST_ISSUE_INVOICE";

// DOWNLOAD_XML
export const DOWNLOAD_XML_ISSUE_INVOICE = "DOWNLOAD_XML_ISSUE_INVOICE";
export const DOWNLOAD_XML_ISSUE_INVOICE_SUCCESS =
  "DOWNLOAD_XML_ISSUE_INVOICE_SUCCESS";
export const DOWNLOAD_XML_ISSUE_INVOICE_FAIL =
  "DOWNLOAD_XML_ISSUE_INVOICE_FAIL";
export const RESET_DOWNLOAD_XML_ISSUE_INVOICE =
  "RESET_DOWNLOAD_XML_ISSUE_INVOICE";
//TRANSFER_USB_INVOICE
export const TRANSFER_USB_INVOICE = "TRANSFER_USB_INVOICE";
export const TRANSFER_USB_INVOICE_SUCCESS = "TRANSFER_USB_INVOICE_SUCCESS";
export const TRANSFER_USB_INVOICE_FAIL = "TRANSFER_USB_INVOICE_FAIL";
export const RESET_TRANSFER_USB_INVOICE = "RESET_TRANSFER_USB_INVOICE";
//GENERATE_NUMBER_INVOICE
export const GENERATE_NUMBER_INVOICE = "GENERATE_NUMBER_INVOICE";
export const GENERATE_NUMBER_INVOICE_SUCCESS =
  "GENERATE_NUMBER_INVOICE_SUCCESS";
export const GENERATE_NUMBER_INVOICE_FAIL = "GENERATE_NUMBER_INVOICE_FAIL";
export const RESET_GENERATE_NUMBER_INVOICE = "RESET_GENERATE_NUMBER_INVOICE";

// PREVIEW_PDF_ISSUE_INVOICE
export const PREVIEW_PDF_ISSUE_INVOICE = "PREVIEW_PDF_ISSUE_INVOICE";
export const PREVIEW_PDF_ISSUE_INVOICE_SUCCESS =
  "PREVIEW_PDF_ISSUE_INVOICE_SUCCESS";
export const PREVIEW_PDF_ISSUE_INVOICE_FAIL = "PREVIEW_PDF_ISSUE_INVOICE_FAIL";
export const RESET_PREVIEW_PDF_ISSUE_INVOICE =
  "RESET_PREVIEW_PDF_ISSUE_INVOICE";

// DELETE_ISSUE_INVOICE
export const DELETE_ISSUE_INVOICE = "DELETE_ISSUE_INVOICE";
export const DELETE_ISSUE_INVOICE_SUCCESS = "DELETE_ISSUE_INVOICE_SUCCESS";
export const DELETE_ISSUE_INVOICE_FAIL = "DELETE_ISSUE_INVOICE_FAIL";
export const RESET_DELETE_ISSUE_INVOICE = "RESET_DELETE_ISSUE_INVOICE";

// Cancel_ISSUE_INVOICE
export const CANCEL_ISSUE_INVOICE = "CANCEL_ISSUE_INVOICE";
export const CANCEL_ISSUE_INVOICE_SUCCESS = "CANCEL_ISSUE_INVOICE_SUCCESS";
export const CANCEL_ISSUE_INVOICE_FAIL = "CANCEL_ISSUE_INVOICE_FAIL";
export const RESET_CANCEL_ISSUE_INVOICE = "RESET_CANCEL_ISSUE_INVOICE";

// Clone Envoice
export const CLONE_ENVOICE = "CLONE_ENVOICE";
export const CLONE_ENVOICE_SUCCESS = "CLONE_ENVOICE_SUCCESS";
export const CLONE_ENVOICE_FAIL = "CLONE_ENVOICE_FAIL";
export const RESET_CLONE_ENVOICE = "RESET_CLONE_ENVOICE";

// SEND_MAIL_INVOICE
export const SEND_MAIL_INVOICE = "SEND_MAIL_INVOICE";
export const SEND_MAIL_INVOICE_SUCCESS = "SEND_MAIL_INVOICE_SUCCESS";
export const SEND_MAIL_INVOICE_FAIL = "SEND_MAIL_INVOICE_FAIL";
export const RESET_SEND_MAIL_INVOICE = "RESET_SEND_MAIL_INVOICE";

// ATTACK_FILE_INVOICE_UPLOAD
export const ATTACK_FILE_INVOICE_UPLOAD = "ATTACK_FILE_INVOICE_UPLOAD";
export const ATTACK_FILE_INVOICE_UPLOAD_SUCCESS =
  "ATTACK_FILE_INVOICE_UPLOAD_SUCCESS";
export const ATTACK_FILE_INVOICE_UPLOAD_FAIL =
  "ATTACK_FILE_INVOICE_UPLOAD_FAIL";
export const ATTACK_FILE_INVOICE_UPLOAD_RESET =
  "ATTACK_FILE_INVOICE_UPLOAD_RESET";

// GET_INVOICE_REPORT_WORD
export const GET_INVOICE_REPORT_WORD = "GET_INVOICE_REPORT_WORD";
export const GET_INVOICE_REPORT_WORD_SUCCESS =
  "GET_INVOICE_REPORT_WORD_SUCCESS";
export const GET_INVOICE_REPORT_WORD_FAIL = "GET_INVOICE_REPORT_WORD_FAIL";
export const RESET_GET_INVOICE_REPORT_WORD = "RESET_GET_INVOICE_REPORT_WORD";

// ACTION_WORKFLOW_ISSUE_INVOICE
// SUBMIT/APPROVE/REJECT
export const ACTION_WORKFLOW_ISSUE_INVOICE = "ACTION_WORKFLOW_ISSUE_INVOICE";
export const ACTION_WORKFLOW_ISSUE_INVOICE_SUCCESS =
  "ACTION_WORKFLOW_ISSUE_INVOICE_SUCCESS";
export const ACTION_WORKFLOW_ISSUE_INVOICE_FAIL =
  "ACTION_WORKFLOW_ISSUE_INVOICE_FAIL";
export const RESET_ACTION_WORKFLOW_ISSUE_INVOICE =
  "RESET_ACTION_WORKFLOW_ISSUE_INVOICE";

// Tạo hóa đơn doanh nghiệp từ hóa đơn khách hàng lẻ
export const CREATE_ISSUE_INVOICE_ENTERPRISE =
  "CREATE_ISSUE_INVOICE_ENTERPRISE";
export const CREATE_ISSUE_INVOICE_ENTERPRISE_SUCCESS =
  "CREATE_ISSUE_INVOICE_ENTERPRISE_SUCCESS";
export const CREATE_ISSUE_INVOICE_ENTERPRISE_FAIL =
  "CREATE_ISSUE_INVOICE_ENTERPRISE_FAIL";
export const RESET_CREATE_ISSUE_INVOICE_ENTERPRISE =
  "RESET_CREATE_ISSUE_INVOICE_ENTERPRISE";

// Tạo hóa đơn điều chỉnh giảm 100%
export const CREATE_ISSUE_INVOICE_ENTERPRISE_ADJUST_ALL =
  "CREATE_ISSUE_INVOICE_ENTERPRISE_ADJUST_ALL";
export const CREATE_ISSUE_INVOICE_ENTERPRISE_ADJUST_ALL_SUCCESS =
  "CREATE_ISSUE_INVOICE_ENTERPRISE_ADJUST_ALL_SUCCESS";
export const CREATE_ISSUE_INVOICE_ENTERPRISE_ADJUST_ALL_FAIL =
  "CREATE_ISSUE_INVOICE_ENTERPRISE_ADJUST_ALL_FAIL";
export const RESET_CREATE_ISSUE_INVOICE_ENTERPRISE_ADJUST_ALL =
  "RESET_CREATE_ISSUE_INVOICE_ENTERPRISE_ADJUST_ALL";

// UPLOAD_FILE_INVOICE
export const UPLOAD_FILE_INVOICE = "UPLOAD_FILE_INVOICE";
export const UPLOAD_FILE_INVOICE_SUCCESS = "UPLOAD_FILE_INVOICE_SUCCESS";
export const UPLOAD_FILE_INVOICE_FAIL = "UPLOAD_FILE_INVOICE_FAIL";
export const UPLOAD_FILE_INVOICE_RESET = "UPLOAD_FILE_INVOICE_RESET";

// EXPORT_INVOICE
export const EXPORT_INVOICE = "EXPORT_INVOICE";
export const EXPORT_INVOICE_SUCCESS = "EXPORT_INVOICE_SUCCESS";
export const EXPORT_INVOICE_FAIL = "EXPORT_INVOICE_FAIL";
export const EXPORT_INVOICE_RESET = "EXPORT_INVOICE_RESET";

// EXPORT_INVOICE_TICKET
export const EXPORT_INVOICE_TICKET = "EXPORT_INVOICE_TICKET";
export const EXPORT_INVOICE_TICKET_SUCCESS = "EXPORT_INVOICE_TICKET_SUCCESS";
export const EXPORT_INVOICE_TICKET_FAIL = "EXPORT_INVOICE_TICKET_FAIL";
export const EXPORT_INVOICE_TICKET_RESET = "EXPORT_INVOICE_TICKET_RESET";

// EXPORT_INVOICE_WAREHOUSES
export const EXPORT_INVOICE_WAREHOUSES = "EXPORT_INVOICE_WAREHOUSES";
export const EXPORT_INVOICE_WAREHOUSES_SUCCESS =
  "EXPORT_INVOICE_WAREHOUSES_SUCCESS";
export const EXPORT_INVOICE_WAREHOUSES_FAIL = "EXPORT_INVOICE_WAREHOUSES_FAIL";
export const EXPORT_INVOICE_WAREHOUSES_RESET =
  "EXPORT_INVOICE_WAREHOUSES_RESET";

// EXPORT_INVOICE_WAREHOUSES_AGENCY
export const EXPORT_INVOICE_WAREHOUSES_AGENCY =
  "EXPORT_INVOICE_WAREHOUSES_AGENCY";
export const EXPORT_INVOICE_WAREHOUSES_AGENCY_SUCCESS =
  "EXPORT_INVOICE_WAREHOUSES_AGENCY_SUCCESS";
export const EXPORT_INVOICE_WAREHOUSES_AGENCY_FAIL =
  "EXPORT_INVOICE_WAREHOUSES_AGENCY_FAIL";
export const EXPORT_INVOICE_WAREHOUSES_AGENCY_RESET =
  "EXPORT_INVOICE_WAREHOUSES_AGENCY_RESET";

// INVOICE_CAMPAIGN_LIST
export const INVOICE_CAMPAIGN_LIST = "INVOICE_CAMPAIGN_LIST";
export const INVOICE_CAMPAIGN_LIST_SUCCESS = "INVOICE_CAMPAIGN_LIST_SUCCESS";
export const INVOICE_CAMPAIGN_LIST_FAIL = "INVOICE_CAMPAIGN_LIST_FAIL";
export const INVOICE_CAMPAIGN_LIST_RESET = "INVOICE_CAMPAIGN_LIST_RESET";
export const SET_COLUMN_VISIBLE_INVOICE_CAMPAIGN_LIST =
  "SET_COLUMN_VISIBLE_INVOICE_CAMPAIGN_LIST";

// UPLOAD_CAMPAIGNS_INVOICE
export const UPLOAD_CAMPAIGNS_INVOICE = "UPLOAD_CAMPAIGNS_INVOICE";
export const UPLOAD_CAMPAIGNS_INVOICE_SUCCESS =
  "UPLOAD_CAMPAIGNS_INVOICE_SUCCESS";
export const UPLOAD_CAMPAIGNS_INVOICE_FAIL = "UPLOAD_CAMPAIGNS_INVOICE_FAIL";
export const UPLOAD_CAMPAIGNS_INVOICE_RESET = "UPLOAD_CAMPAIGNS_INVOICE_RESET";

// RELEASE_CAMPAIGNS_INVOICE
export const RELEASE_CAMPAIGNS_INVOICE = "RELEASE_CAMPAIGNS_INVOICE";
export const RELEASE_CAMPAIGNS_INVOICE_SUCCESS =
  "RELEASE_CAMPAIGNS_INVOICE_SUCCESS";
export const RELEASE_CAMPAIGNS_INVOICE_FAIL = "RELEASE_CAMPAIGNS_INVOICE_FAIL";
export const RELEASE_CAMPAIGNS_INVOICE_RESET =
  "RELEASE_CAMPAIGNS_INVOICE_RESET";

// INVOICE_CAMPAIGN_DETAIL
export const INVOICE_CAMPAIGN_DETAIL = "INVOICE_CAMPAIGN_DETAIL";
export const INVOICE_CAMPAIGN_DETAIL_SUCCESS =
  "INVOICE_CAMPAIGN_DETAIL_SUCCESS";
export const INVOICE_CAMPAIGN_DETAIL_FAIL = "INVOICE_CAMPAIGN_DETAIL_FAIL";
export const INVOICE_CAMPAIGN_DETAIL_RESET = "INVOICE_CAMPAIGN_DETAIL_RESET";

// GET_DATA_LINK
export const GET_DATA_LINK = "GET_DATA_LINK";
export const GET_DATA_LINK_SUCCESS = "GET_DATA_LINK_SUCCESS";
export const GET_DATA_LINK_FAIL = "GET_DATA_LINK_FAIL";
export const GET_DATA_LINK_RESET = "GET_DATA_LINK_RESET";

// GET_INVOICE_MAX_DATE
export const GET_INVOICE_MAX_DATE = "GET_INVOICE_MAX_DATE";
export const GET_INVOICE_MAX_DATE_SUCCESS = "GET_INVOICE_MAX_DATE_SUCCESS";
export const GET_INVOICE_MAX_DATE_FAIL = "GET_INVOICE_MAX_DATE_FAIL";
export const GET_INVOICE_MAX_DATE_RESET = "GET_INVOICE_MAX_DATE_RESET";

// GET_INVOICE_MIN_DATE
export const GET_INVOICE_MIN_DATE = "GET_INVOICE_MIN_DATE";
export const GET_INVOICE_MIN_DATE_SUCCESS = "GET_INVOICE_MIN_DATE_SUCCESS";
export const GET_INVOICE_MIN_DATE_FAIL = "GET_INVOICE_MIN_DATE_FAIL";
export const GET_INVOICE_MIN_DATE_RESET = "GET_INVOICE_MIN_DATE_RESET";

// DOWNLOAD_ZIP_INVOICE
export const DOWNLOAD_ZIP_INVOICE = "DOWNLOAD_ZIP_INVOICE";
export const DOWNLOAD_ZIP_INVOICE_SUCCESS = "DOWNLOAD_ZIP_INVOICE_SUCCESS";
export const DOWNLOAD_ZIP_INVOICE_FAIL = "DOWNLOAD_ZIP_INVOICE_FAIL";
export const RESET_DOWNLOAD_ZIP_INVOICE = "RESET_DOWNLOAD_ZIP_INVOICE";

// BK_DATA_NEW
export const BK_DATA_NEW = "BK_DATA_NEW";
export const RESET_BK_DATA_NEW = "RESET_BK_DATA_NEW";

// GET_CURRENT_TIME
export const GET_CURRENT_TIME = "GET_CURRENT_TIME";
export const GET_CURRENT_TIME_SUCCESS = "GET_CURRENT_TIME_SUCCESS";
export const GET_CURRENT_TIME_FAIL = "GET_CURRENT_TIME_FAIL";
